import { FormattedMessage } from 'gatsby-plugin-intl';
import * as React from 'react';
import { Col, Grid, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { useTheme } from '../../../hooks/useTheme';
import SectionPath from '../../../styles/static/fourthSectionPath.svg';
import { media } from '../../../styles/theme';
import { ButtonPrimary } from '../../common/Buttons';
import { Flex } from '../../common/Flex';
import { Indent } from '../../common/Indent';
import { StyledText } from '../../common/StyledText';
import { TitleLine } from '../../common/TitleLine';
import { VimeoPlayer } from '../../common/VimeoPlayer';
import { Counters } from './Counters';
import { PartnerDashboardBlock } from './PartnerDashboardBlock';
import { AuthDrawerEvent } from '../../common/AuthDrawer';

export const Dashboard = () => {
  const theme = useTheme();
  return (
    <Section>
      <SectionBackground>
        <SectionPath />
      </SectionBackground>
      <Grid>
        <Flex justify='center'>
          <Indent vertical={2.5}>
            <Flex direction='column' align='center'>
              <Indent bottom={2}>
                <h2>
                  <StyledText
                    color='textInverted'
                    size='2'
                    smSize='2.625'
                    lineHeight='1.2'
                    align='center'
                    type='inline-block'>
                    <FormattedMessage id='homepage.fourthSection.title' />
                  </StyledText>
                </h2>
              </Indent>
              <Indent smBottom={0.5} width='100%'>
                <Flex justify='center'>
                  <TitleLine width='80%' />
                </Flex>
              </Indent>
            </Flex>
          </Indent>
        </Flex>
        <Row>
          <Col xs={12} md={6}>
            <Row>
              <Col xs={12} sm={6}>
                <PartnerDashboardBlock
                  icon='flip'
                  title={<FormattedMessage id='homepage.partnerFirstDashboardBlock.title' />}
                  description={<FormattedMessage id='homepage.partnerFirstDashboardBlock.description' />}
                />
              </Col>
              <Col xs={12} sm={6}>
                <PartnerDashboardBlock
                  icon='lifebuoy'
                  title={<FormattedMessage id='homepage.partnerSecondDashboardBlock.title' />}
                  description={<FormattedMessage id='homepage.partnerSecondDashboardBlock.description' />}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6}>
                <PartnerDashboardBlock
                  icon='search'
                  title={<FormattedMessage id='homepage.partnerThirdDashboardBlock.title' />}
                  description={<FormattedMessage id='homepage.partnerThirdDashboardBlock.description' />}
                />
              </Col>
              <Col xs={12} sm={6}>
                <PartnerDashboardBlock
                  icon='userGroup'
                  title={<FormattedMessage id='homepage.partnerFourthDashboardBlock.title' />}
                  description={<FormattedMessage id='homepage.partnerFourthDashboardBlock.description' />}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={6}>
            <Indent top={1.5} bottom={3} type='block'>
              <DashboardBox>
                <VimeoPlayer
                  videoParams={{
                    id: '397145124',
                    color: theme.primaryColor,
                    title: 0,
                    byline: 0,
                    portrait: 0,
                  }}
                />
              </DashboardBox>
            </Indent>
            <Flex justify='center'>
              <Indent>
                <ButtonPrimary
                  onClick={() => {
                    AuthDrawerEvent.emit('registration');
                  }}>
                  <FormattedMessage id='homepage.firstSection.openAccountBtn' />
                </ButtonPrimary>
              </Indent>
            </Flex>
          </Col>
        </Row>
        <Counters />
      </Grid>
    </Section>
  );
};

const DashboardBox = styled.div`
  background: #374566;
  box-shadow: 0 5px 34px 0 rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  padding: 56.25% 0 0 0;
  position: relative;
  width: 100%;
  overflow: hidden;
`;

const SectionBackground = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(40%, -30%);
  z-index: -1;

  svg {
    width: 240px;
    height: 260px;
  }

  ${media.sm`
    transform: translate(-40%, 30%);
    bottom: 0;
    left: 0;
    top: auto;
    right: auto;

    svg {
      width: 590px;
      height: 660px;;
    }
  `};
`;

const Section = styled.div`
  position: relative;
  overflow: hidden;
  padding-bottom: 50px;
  background: #29304d;

  ${media.sm`padding-bottom: 100px;`};
`;
